<ion-content class="modal-options ion-padding">
  <div class="option-row" (click)="selectDetails()">
    <ion-icon name="information-circle-outline" class="option-icon" />
    <span>{{ "top-products.selections.details" | translate }}</span>
  </div>

  @if (isTicketSold || isDirectSale) {
  <div class="option-row" (click)="goToProductTicketSoldInfo(product.id)">
    <ion-icon name="list-outline" class="option-icon" />
    <span>{{ "top-products.selections.ticket-sold-info" | translate }}</span>
  </div>
  } @if (isExclusiveProduct) {
  <div class="option-row" (click)="selectGenerateCode()">
    <ion-icon name="key-outline" class="option-icon" />
    <span>{{ "exclusive-tab.generate_code" | translate }}</span>
  </div>
  } @if (isPromotionalProduct) {
  <div class="option-row" (click)="selectShareLink()">
    <img src="assets/icons/share-icon.svg" class="option-icon" />
    <span>{{ "promotional-tab.share_link" | translate }}</span>
  </div>
  } @if (isDirectSale && !isProductComplete) {
  <div class="option-row" (click)="selectGenerateTicket()">
    <ion-icon name="ticket-outline" class="option-icon"></ion-icon>
    <span>{{ "payment-product-modal.generate-ticket" | translate }}</span>
  </div>
  }
</ion-content>
